export enum DrillDownMode {
  SCORES = 's',
  IMPACT_TOPICS = 'it',
}
